import React from 'react';
import './Cctv.css';

const Cctv: React.FC = () => {
  return (
    <div className="cctv-page">

      {/* ── Hero ── */}
      <section className="cctv-hero">
        <div className="container cctv-hero-content">
          <span className="cctv-label cctv-label--light">Sistema de videovigilancia</span>
          <h1>Aviso de Privacidad</h1>
          <p>
            Documento vinculado al código QR de los letreros de videovigilancia instalados
            en las áreas monitoreadas de Automatización, Básculas y Control, S.A. de C.V.
          </p>
        </div>
      </section>

      {/* ── Document ── */}
      <section className="cctv-document">
        <div className="container cctv-document-wrap">

          <header className="cctv-doc-header">
            <h2>AUTOMATIZACIÓN, BÁSCULAS Y CONTROL, S.A. DE C.V.</h2>
            <p><strong>RFC:</strong> ABC960829428</p>
            <p><strong>Domicilio:</strong> Av. Tabachines No. 3750, Col. Loma Bonita Ejidal, C.P. 45085, Zapopan, Jalisco</p>
          </header>

          <p className="cctv-doc-emphasis">
            Emitido en cumplimiento de la Ley Federal de Protección de Datos Personales en Posesión de los Particulares (LFPDPPP)
          </p>

          <p>
            Este aviso aplica a cualquier persona —empleado, visitante, cliente, proveedor o cualquier otra
            persona— cuya imagen sea captada por las cámaras de videovigilancia instaladas en las áreas
            señaladas con este letrero.
          </p>

          <section className="cctv-doc-section">
            <h3>1. Identidad y domicilio del responsable</h3>
            <p>
              Automatización, Básculas y Control, S.A. de C.V. ("la Empresa"), con domicilio en Av. Tabachines
              No. 3750, Colonia Loma Bonita Ejidal, Zapopan, Jalisco, C.P. 45085, es responsable del tratamiento
              de los datos personales captados a través de su sistema de videovigilancia.
            </p>
          </section>

          <section className="cctv-doc-section">
            <h3>2. Datos personales que se recaban</h3>
            <p>A través de las cámaras instaladas se recaba únicamente:</p>
            <ul>
              <li>Imagen captada en video de las personas que ingresan o transitan por las áreas monitoreadas.</li>
            </ul>
            <p>No se instalan cámaras en baños, vestidores ni en áreas donde se afecte la intimidad de las personas.</p>
          </section>

          <section className="cctv-doc-section">
            <h3>3. Finalidades del tratamiento</h3>
            <p>La imagen captada se utiliza para:</p>
            <ul>
              <li>Garantizar la seguridad física de empleados, visitantes e instalaciones.</li>
              <li>Prevenir y disuadir actos delictivos o irregulares.</li>
              <li>Contar con evidencia en caso de robos, accidentes o incidentes de seguridad.</li>
              <li>Proteger las instalaciones, el inventario y los activos de la Empresa.</li>
              <li>Control de acceso a las instalaciones.</li>
            </ul>
            <p>No se utiliza para fines distintos a los aquí señalados.</p>
          </section>

          <section className="cctv-doc-section">
            <h3>4. Fundamento legal</h3>
            <p>El tratamiento de estos datos se realiza con fundamento en:</p>
            <ul>
              <li>Artículo 16 de la Constitución Política de los Estados Unidos Mexicanos, que reconoce el derecho a la protección de los datos personales.</li>
              <li>Ley Federal de Protección de Datos Personales en Posesión de los Particulares (LFPDPPP) y su Reglamento.</li>
            </ul>
            <p>
              Para las personas que tienen una relación laboral con la Empresa, el tratamiento de estos datos
              se rige además por el Aviso de Privacidad para Empleados y la Política de Monitoreo, Uso de
              Herramientas, Sistemas y Medios Digitales, con fundamento adicional en los artículos 132 y 134
              de la Ley Federal del Trabajo. Dichos documentos pueden solicitarse en el área de Recursos Humanos.
            </p>
          </section>

          <section className="cctv-doc-section">
            <h3>5. Conservación de las grabaciones</h3>
            <p>
              Las grabaciones se conservan por un periodo máximo de 30 días naturales, salvo que exista una
              investigación interna, un requerimiento de autoridad competente o un incidente documentado que
              justifique conservarlas por más tiempo.
            </p>
          </section>

          <section className="cctv-doc-section">
            <h3>6. Transferencia de datos</h3>
            <p>La imagen captada podrá compartirse, sin necesidad de consentimiento del titular, únicamente cuando:</p>
            <ul>
              <li>Lo exija una disposición legal.</li>
              <li>Sea requerida por una autoridad competente (laboral, fiscal, de seguridad o de procuración de justicia).</li>
            </ul>
            <p>La Empresa no comercializa ni comparte estas grabaciones con fines distintos a los señalados en este aviso.</p>
          </section>

          <section className="cctv-doc-section">
            <h3>7. Derechos ARCO (Acceso, Rectificación, Cancelación u Oposición)</h3>
            <p>
              Si su imagen fue captada por el sistema de videovigilancia, usted puede solicitar el acceso a la
              grabación en la que aparece, dirigiendo su solicitud por escrito a:
            </p>
            <ul>
              <li><strong>Correo electrónico:</strong> <a href="mailto:compliance@abcscale.mx">compliance@abcscale.mx</a></li>
            </ul>
            <p>
              La solicitud debe incluir: nombre completo, domicilio o correo para recibir notificaciones, copia
              de identificación oficial, y una descripción clara de la fecha, horario y lugar aproximado de la
              grabación que solicita.
            </p>
            <p>
              La Empresa responderá en un plazo máximo de 20 días hábiles. El acceso podrá otorgarse de forma
              limitada —por ejemplo, mediante visualización controlada— cuando sea necesario para proteger
              derechos de terceros, investigaciones en curso, la seguridad de las instalaciones o por
              disposición legal.
            </p>
          </section>

          <section className="cctv-doc-section">
            <h3>8. Medidas de seguridad</h3>
            <p>
              La Empresa cuenta con medidas administrativas, técnicas y físicas para proteger las grabaciones
              contra daño, pérdida, alteración, destrucción, uso, acceso o divulgación no autorizados.
            </p>
          </section>

          <section className="cctv-doc-section">
            <h3>9. Cambios a este aviso</h3>
            <p>
              Cualquier modificación a este aviso será publicada en este mismo medio (documento vinculado al
              código QR) y, cuando aplique, comunicada en las instalaciones de la Empresa con al menos 5 días
              hábiles de anticipación.
            </p>
          </section>

          <hr className="cctv-doc-divider" />

          <footer className="cctv-doc-footer">
            <p><strong>AUTOMATIZACIÓN, BÁSCULAS Y CONTROL, S.A. DE C.V.</strong></p>
            <p>Versión: 1.0 · Fecha de emisión: 15 de enero de 2026</p>
            <p className="cctv-doc-legal">
              Documento propiedad de AUTOMATIZACIÓN, BÁSCULAS Y CONTROL, S.A. DE C.V. Su reproducción,
              divulgación o uso no autorizado está prohibido, sin perjuicio de los derechos que la legislación
              reconoce a los titulares de los datos personales.
            </p>
          </footer>

        </div>
      </section>

    </div>
  );
};

export default Cctv;
